import { FC } from 'react';
import { Flex, FlexProps } from '@chakra-ui/react';

export const BaseContainer: FC<FlexProps> = ({ children, ...props }) => (
  <Flex minH="100vh" w="full" {...props}>
    {children}
  </Flex>
);
